export const ch_title_dict = {
  room1_hex_mean: 'Стоимость 1 кв метра для однокомнатных квартир',
  room2_hex_mean: 'Стоимость 1 кв метра для двухкомнатных квартир',
  room3_hex_mean: 'Стоимость 1 кв метра для трехкомнатных квартир',
  room4_hex_mean: 'Стоимость 1 кв метра для четырех- и более комнатных квартир',

  room1_hex_mean_full: 'Стоимость однокомнатной квартиры',
  room2_hex_mean_full: 'Стоимость двухкомнатной квартиры',
  room3_hex_mean_full: 'Стоимость трехкомнатной квартиры',
  room4_hex_mean_full: 'Стоимость четырех- и более комнатных квартир',
};
